import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Frontline } from '@/features/frontline'

const frontlineSearchSchema = z
  .object({
    branch: z.string().optional(),
    agent: z.string().optional(),
    tab: z
      .enum(['leads', 'customers', 'agents', 'pending-assignments'])
      .optional(),
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/frontline/')({
  validateSearch: frontlineSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/frontline',
        search: {
          branch: search?.branch,
          agent: search?.agent,
          tab: search?.tab,
          language: 'en',
        },
      })
    }
  },
  component: Frontline,
})
